/* RESPONSIBLE TEAM: team-frontend-tech */

import ENV from 'embercom/config/environment';

const STORAGE_KEY = '__ISLAND_BOOT_START_TIME';
const STALE_THRESHOLD_MS = 300000;
const SEND_DEBOUNCE_MS = 5000;

function getEmberDevServerOrigin(): string {
  let protocol = window.location.protocol;
  let hostname = window.location.hostname;
  if (hostname.endsWith('.intercom.test')) {
    let prefix = hostname.replace('.intercom.test', '');
    if (prefix !== 'app' && prefix !== 'intercomrades') {
      return `${protocol}//${prefix}.embercom.test`;
    }
  }
  return `${protocol}//embercom.test`;
}

function sendToServer(data: Record<string, unknown>): void {
  let params = new URLSearchParams();
  params.set('ts', String(Date.now()));
  params.set('url', window.location.pathname);
  for (let [key, value] of Object.entries(data)) {
    params.set(key, String(value));
  }
  fetch(`${getEmberDevServerOrigin()}/dev/island-metrics?${params}`).catch(() => {});
}

export function recordIslandBootStart(): void {
  if (ENV.environment !== 'development') {
    return;
  }
  let stored = sessionStorage.getItem(STORAGE_KEY);
  if (!stored || Date.now() - Number(stored) > STALE_THRESHOLD_MS) {
    sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
  }
}

export function sendIslandBootSuccess(): void {
  if (ENV.environment !== 'development') {
    return;
  }
  let startTimeStr = sessionStorage.getItem(STORAGE_KEY);
  if (!startTimeStr) {
    return;
  }
  let timeTaken = Date.now() - Number(startTimeStr);
  setTimeout(() => {
    sessionStorage.removeItem(STORAGE_KEY);
    sendToServer({ event_type: 'island_boot_success', time_taken: timeTaken });
  }, SEND_DEBOUNCE_MS);
}

export function sendIslandBootError(errorCategory: string, errorMessage: string): void {
  if (ENV.environment !== 'development') {
    return;
  }
  sessionStorage.removeItem(STORAGE_KEY);
  sendToServer({
    event_type: 'island_boot_error',
    error_category: errorCategory,
    error_message: errorMessage,
  });
}
